import { IAppConfig } from '@estee/elc-universal-utils';
import { getDecorators, ServiceManager } from '@estee/elc-service';
import { Container } from 'hypo-container';
import { AnalyticsDriver } from './../internal/AnalyticsDriver';
import { EventSubmitter } from '../internal/EventSubmitter';
import { EventRepository } from '~repositories/EventRepository';
import { DataAggregator } from '../internal/DataAggregator';
import { ServiceBusController } from './ServiceBusController';
import serviceNames, { AnalyticsService } from './AnalyticsService';
import { ConfigStore } from './ConfigStore';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.eventRepository, (c) => new EventRepository())
    .register(
        serviceNames.dataAggregator,
        (c) => new DataAggregator(c.get(serviceNames.eventRepository))
    )

    .register(serviceNames.serviceBusController, (c) => new ServiceBusController())
    .register(serviceNames.analyticsDriver, (c) => new AnalyticsDriver())
    .register(
        serviceNames.eventSubmitter,
        (c) =>
            new EventSubmitter(
                c.get(serviceNames.analyticsDriver),
                c.get(serviceNames.eventRepository)
            )
    )
    .register(
        serviceNames.analyticsService,
        (c) =>
            new AnalyticsService((config: IAppConfig) => {
                setConfig(config);

                c.get(serviceNames.dataAggregator);
                c.get(serviceNames.eventSubmitter);
                c.get(serviceNames.serviceBusController);
            })
    );

export const serviceStarter = ServiceManager.startService;

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
